import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import "element-ui/lib/theme-chalk/index.css";
import "../public/font-awesome/css/font-awesome.min.css";
import "../public/less/main.less";
import Util from "./util/util.js";

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(Util);

document.title = "IPO上市募投可研编制专家 - 美信咨询";

const Index = () => import("./pages/index.vue");
const About = () => import("./pages/about.vue");
const Criterion = () => import("./pages/criterion.vue");
const Special = () => import("./pages/special.vue");
const Partner = () => import("./pages/partner.vue");
const Job = () => import("./pages/job.vue");
const Advantage = () => import("./pages/advantage.vue");
const Contact = () => import("./pages/contact.vue");

const ArticleCreate = () => import("./pages/article/create.vue");

let bus = new Vue();
Vue.prototype.bus = bus;

const router = new VueRouter({
    routes: [
        {
            path: "/",
            name: "index",
            component: Index
        },
        {
            path: "/about",
            name: "about",
            component: About
        },
        {
            path: "/criterion",
            name: "criterion",
            component: Criterion
        },
        {
            path: "/special",
            name: "special",
            component: Special
        },
        {
            path: "/partner",
            name: "partner",
            component: Partner
        },
        {
            path: "/job",
            name: "job",
            component: Job
        },
        {
            path: "/advantage",
            name: "advantage",
            component: Advantage
        },
        {
            path: "/contact",
            name: "contact",
            component: Contact
        },

        {
            path: "/article/create",
            name: "article.create",
            component: ArticleCreate
        },
        {
            path: "/article/create/:id",
            name: "article.create",
            component: ArticleCreate
        },
    ]
});
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        //document.title = "IPO上市募投可研编制专家 - 美信咨询";
    }
    if (to.name) {
        document.body.setAttribute('page', to.name.replace(".", "-"));
    }

    next();
});
router.afterEach((to, from) => {
    window.scrollTo(0, 0);
});

new Vue({
    render: h => h(App),
    router
}).$mount("#app");
